import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { FeatureCodeComboBoxModel } from '../feature-code-combo-box.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 特集コードリストを取得する
 *
 * @export API通信成功時の処理
 * @class KYMW68GetFeatureCodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class KYMW68GetFeatureCodeListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: FeatureCodeComboBoxModel;
  private mediumType = '';
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof KYMW68GetFeatureCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {FeatureCodeComboBoxModel} model
   * @param {string} mediumType
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof KYMW68GetFeatureCodeListService
   */
  execute(model: FeatureCodeComboBoxModel, mediumType: string, successFunc: () => void = null): void {
    this.model = model;
    this.mediumType = mediumType;
    this.successFunc = successFunc;
    this.send('KYMW68getFeatureList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof KYMW68GetFeatureCodeListService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.updateDataList(data.FeatureList);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}